import { Project, ProjectStateTypes } from '../../types/project'
import { Text } from '@/components/commons/typography/Text'
import { Badge } from '@mantine/core'
import { Carousel } from '@mantine/carousel'
import { classNames } from 'react-notion'
import { User } from 'containers/user/types/user'
import { joinWithSlash } from 'utilities/links'
import { SliderImageWrapper } from './SliderImage'
import { ProjectImage } from '../ProjectImage'
import { useContext } from 'react'
import { BrowserContext } from 'context'

interface ProjectThumbnailProps {
  project: Project
  profile: User
  isInProject?: boolean
}

export const ProjectThumbnail = ({
  project,
  profile,
  isInProject,
}: ProjectThumbnailProps) => {
  const gallery = project?.gallery?.filter((image) => !!image && image !== null) || []
  const isStaffPick = project?.staffPick

  const { isMobile } = useContext(BrowserContext)

  const carouselStyles = {
    aspectRatio: isMobile ? '255/225' : '510/225',
    slideSize: isMobile ? '100%' : gallery.length <= 1 ? '100%' : '50%',
    slideToSCroll: isMobile ? 1 : gallery.length <= 1 ? 1 : 2,
    showControls: isMobile ? gallery.length > 1 : gallery.length > 2,
  }
  const slideAspectRatio =
    isMobile || !isInProject
      ? '255/225'
      : gallery.length <= 1
      ? '510/225'
      : '255/225'

  const aspectRatio = !isInProject ? '255/225' : carouselStyles.aspectRatio
  const slideSizes = !isInProject ? '100%' : carouselStyles.slideSize
  const slidesToScroll = !isInProject ? 1 : carouselStyles.slideToSCroll

  return (
    <div className="relative rounded-t-10 full-w">
      {gallery.length > 0 && (
        <div style={{ aspectRatio }} className="flex rounded-t-10 bg-white">
          <Carousel
            withIndicators={carouselStyles.showControls}
            height={'100%'}
            style={{ flex: 1 }}
            slideSize={slideSizes}
            slidesToScroll={slidesToScroll}
            slideGap="md"
            loop
            classNames={{
              controls: !carouselStyles.showControls ? 'hidden' : '',
            }}
          >
            {gallery.map((image) => (
              <Carousel.Slide
                key={image}
                style={{ slideAspectRatio }}
                className={'relative bg-white'}
              >
                <SliderImageWrapper
                  link={
                    isInProject
                      ? undefined
                      : joinWithSlash(
                          profile?.username?.toLocaleLowerCase(),
                          'projects',
                          project.id
                        )
                  }
                >
                  <ProjectImage
                    image={image}
                    project={project}
                    aspectRatio={slideAspectRatio}
                    rounded={isInProject}
                    imagesCount={gallery.length}
                  />
                </SliderImageWrapper>
              </Carousel.Slide>
            ))}
          </Carousel>
        </div>
      )}

      {isStaffPick && !isInProject && (
        <div
          className={classNames(
            'top-0 right-0 flex gap-8 p-16 z-10',
            gallery?.length > 0
              ? 'top-0 absolute'
              : '-top-8 flex justify-flex-end w-full pb-0'
          )}
        >
          <Badge color="blue" className="text-white uppercase" radius={4}>
            Staff Pick
          </Badge>
        </div>
      )}

      {project?.state === ProjectStateTypes.DRAFT && !isInProject && (
        <div className="absolute top-10 left-10 w-full h-full bg-primary px-12 py-2  opacity-85 z-10 rounded-4">
          <Text variation="xSmall" colorClass="text-secondary">
            Draft
          </Text>
        </div>
      )}
    </div>
  )
}
